import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ProductCard = ({ product, onAddToCart }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="group relative bg-transparent border border-white/5 hover:border-primary/30 transition-all duration-500 overflow-hidden"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/products/${product.id}`}>
        <div className="aspect-[3/4] overflow-hidden relative">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
      </Link>

      <div className="p-6 space-y-3">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <Link to={`/products/${product.id}`}>
              <h3 className="font-display text-xl text-foreground group-hover:text-primary transition-colors duration-300">
                {product.name}
              </h3>
            </Link>
            <p className="text-xs uppercase tracking-widest text-muted-foreground mt-1">
              {product.category}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between">
          {product.variants && product.variants.length > 0 ? (
            <div>
              <p className="text-xs uppercase tracking-widest text-muted-foreground">Starting from</p>
              <p className="font-accent text-2xl italic text-primary">
                ₹{product.variants[0].price.toFixed(2)}
              </p>
            </div>
          ) : (
            <p className="font-accent text-2xl italic text-primary">
              ₹{(product.price || product.base_price || 0).toFixed(2)}
            </p>
          )}
          <button
            onClick={() => onAddToCart(product)}
            data-testid={`add-to-cart-${product.id}`}
            className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full p-3 transition-all duration-300 hover:scale-105 hover:shadow-[0_0_20px_rgba(212,175,55,0.3)]"
          >
            <ShoppingCart size={18} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </motion.div>
  );
};